/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S4_HeadingInputs */

const tr_iade_iptal_s4_heading = /** @type {(inputs: Iade_Iptal_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cayma Hakkından Vazgeçme ve Hizmet Başlangıcı (Mesafeli Yön. Md. 15/1-h)`)
};

const en_iade_iptal_s4_heading = /** @type {(inputs: Iade_Iptal_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Waiver of the Right of Withdrawal and Start of Service (Distance Contracts Regulation, Art. 15/1-h)`)
};

const de_iade_iptal_s4_heading = /** @type {(inputs: Iade_Iptal_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Verzicht auf das Widerrufsrecht und Leistungsbeginn (Verordnung über Fernabsatzverträge, Art. 15/1-h)`)
};

const ru_iade_iptal_s4_heading = /** @type {(inputs: Iade_Iptal_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Отказ от права на отказ и начало оказания услуги (Положение о дистанционных договорах, ст. 15/1-h)`)
};

/**
* | output |
* | --- |
* | "4. Waiver of the Right of Withdrawal and Start of Service (Distance Contracts Regulation, Art. 15/1-h)" |
*
* @param {Iade_Iptal_S4_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s4_heading = /** @type {((inputs?: Iade_Iptal_S4_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S4_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s4_heading(inputs)
	if (locale === "de") return de_iade_iptal_s4_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s4_heading(inputs)
	return tr_iade_iptal_s4_heading(inputs)
});